import { TButtonSize, TButtonTheme } from '@cian/ui-kit/button/types';
import * as React from 'react';

import { useCallbackButton } from './useCallbackButton';
import { CallbackButton } from '../../components/CallbackButton';
import { TCallbackOpener } from '../../types/callbackPopup';

export interface ICallBackButtonContainerProps {
  size?: TButtonSize;
  placeType: TCallbackOpener;
  callbackButtonText?: string;
  beforeIcon?: React.JSX.Element;
  fullWidth?: boolean;
  theme?: TButtonTheme;
}

export function CallBackButtonContainer({
  size = 'M',
  placeType,
  callbackButtonText = 'Заказ звонка',
  beforeIcon,
  fullWidth = true,
  theme = 'fill_secondary',
}: ICallBackButtonContainerProps) {
  const { handleCallbackButtonClick, loading, isCallbackAvailable } = useCallbackButton(placeType);

  if (!isCallbackAvailable) {
    return null;
  }

  return (
    <CallbackButton
      size={size}
      onClick={handleCallbackButtonClick}
      placeType={placeType}
      loading={loading}
      callbackButtonText={callbackButtonText}
      beforeIcon={beforeIcon}
      fullWidth={fullWidth}
      theme={theme}
    />
  );
}
